<template>
  <div
    class="profile-tag"
    :class="className"
    v-if="data && data.tier && data.tier.name && data.tier.name.length > 0"
  >
    {{ data && data.tier ? data.tier.name : "" }}
  </div>
</template>
  
<script>
export default {
  name: "ProfileTierName",
  props: ["data", "className"],
};
</script>
  
<style scoped>
.profile-tag {
  border-radius: 4px;
  background: rgba(45, 109, 204, 0.1);
  color: var(--tierColor1) !important;
  height: 20px;
  padding: 2px 6px !important;
  font-size: 0.75rem !important;
  width: fit-content;
  display: inline-block;
  line-height: 1.25em;
}

.mgt-8 {
  margin-top: 8px !important;
}

.mgl-4 {
  margin-left: 4px !important;
}

.t-color-white {
  color: #fff !important;
}
</style>